export const retryMessage = "x8iRDc";
export const notFoundMessage = "_MttJb";
export const retryActionButtonLabel = "OQP6h";
export const goHomeButtonLabel = "LXFjKb";
export default {retryMessage,notFoundMessage,retryActionButtonLabel,goHomeButtonLabel};